import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { connect } from 'react-redux';
import ga from 'analytics';

import ConfirmContainer from './screens/ConfirmContainer.js'
import MCQContainer from './screens/MCQContainer.js'
import AllDayContainer from './screens/AllDayContainer.js'
import PhotoContainer from './screens/PhotoContainer.js'
import ImageContainer from './screens/ImageContainer.js'
import CountUpContainer from './screens/CountUpContainer.js'
import TimerScreenContainer from './screens/TimerScreenContainer.js'
import NumericInputContainer from './screens/NumericInputContainer.js'
import UnknownChallenge from './UnknownChallenge.js'
import UserChallengeComplete from '../UserChallengeComplete.js';
import LoadInline from 'modules/loading/LoadInline.js';



/*
Requires a steps prop. For example:
steps = [
    {type:'Confirm',         props:{...}},
    {type:'NumericInput',    props:{...}, assign:{'value1':'value'}},
    {type:'Timer',           props:{}},
    {type:'NumericInput',    props:{...},assign:{'value2':'value'}, action:function(vars){ return {value:(vars.value2 - vars.value1)} }},
];
*/

class GenericChallengeContainer extends Component {
    constructor(props){
        super(props);
        this.vars= {}; //Store results of each step here
        this.result = {};
        this.initialState = {stepIndex:0};
        this.state = this.initialState;
        this.next = this.next.bind(this);
        this.onComplete = this.onComplete.bind(this);
    }

    next() {
        var currentStep = this.state.stepIndex;
        if(currentStep === this.props.steps.length-1) {
            this.props.onComplete(this.props.challenge.id, this.result);
        } else {
            this.setState({stepIndex:(currentStep+1)});
        }
    }

    onComplete(data) {
        data = data || {};
        var step = this.props.steps[this.state.stepIndex];
        var assign = step.assign;
        var action = step.action;
        if(assign && data) {
            Object.keys(assign).forEach((key)=>{
                this.vars[key] = data[assign[key]];
            });
        }
        if(action) {
            this.result = action(this.vars);
        }
        this.next();
    }
    getScreen(step) {
        switch(step.type) {
            case 'NumericInput': 
                return NumericInputContainer;
            case 'Timer': 
                return TimerScreenContainer;
            case 'Confirm': 
                return ConfirmContainer;
            case 'Photo': 
                return PhotoContainer;
            case 'Image': 
                return ImageContainer;
            case 'MCQ': 
                return MCQContainer;
            case 'AllDay': 
                return AllDayContainer;
            case 'CountUp': 
                return CountUpContainer;
            default: return UnknownChallenge;
        }
    }
    renderScreen() {
        var index = Math.min(this.props.steps.length-1,this.state.stepIndex);
        var step = this.props.steps[index];
        var Screen = this.getScreen(step);

        return <Screen key={index} 
                    {...step.props}  
                    onComplete={this.onComplete}
                    challenge={this.props.challenge}
                    teamChallengeData={this.props.teamChallengeData}
                    completePending={this.props.completePending}
                    complete={this.props.complete}
                    userChallenge={this.props.userChallenge}
                />;
    }
    render() {
        if(this.props.complete && !this.props.noCompleteScreen) {
            return <UserChallengeComplete challenge={this.props.challenge} 
                                          userChallenge={this.props.userChallenge} 
                                          progress={this.props.progress}
                                          onRepeatLevel={this.props.onRepeatLevel}
                                          onContinue={this.props.onContinue} />  
        } else {
            return this.renderScreen();
        }
    }

}

export default GenericChallengeContainer;


const getChallengeContainer = (getSteps, virtualURL, extraProps) => (
    translate('challenges')(class extends Component {
        constructor(props) {
            super(props);
            this.state = {steps:getSteps(this.props.t)};
        }
        componentWillMount() {
            if(virtualURL) {
                ga('send', 'pageview', { 'page': virtualURL }); 
            }
        }
        render() {
            return <GenericChallengeContainer {...this.props} {...extraProps} steps={this.state.steps}/>;
        }
    })
);

export {getChallengeContainer};



// WEBPACK FOOTER //
// ./src/modules/challenges/types/GenericChallengeContainer.js